/* ============================================================
   Vantor — app-240 real add to cart; app-256 badge + drawer refresh; app-268 cart page stepper + trash.
   Any [data-atc] button adds exactly what vantor-summary.js last painted
   (Vantor.lastQuote.items: variant id, quantity, and the selling plan when the
   line is a preorder). On success: sync badge from cart.item_count, refresh /
   open cart-drawer when present, otherwise go to the cart page. On refusal the
   shopper stays put and reads Shopify's own message.
   app-268: on the cart page − / + / a typed qty / the trash icon post to
   /cart/change.js and Shopify re-renders the section; this file swaps the lines,
   the lead-time note and the Summary in. It does no money maths.
   ============================================================ */
(function (V) {
  var busy = false;

  function fail(q, message) {
    busy = false;
    V.paintSummary(q);   // re-enables the buttons — and clears the error line, so the message goes in after
    document.querySelectorAll('[data-atc-error]').forEach(function (n) { n.textContent = message; n.hidden = false; });
  }

  function syncBadge() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count || 0;
        if (typeof V.setCartCount === 'function') V.setCartCount(n);
        return cart;
      });
  }

  function refreshDrawer(sections) {
    var drawer = (document.querySelector && document.querySelector('cart-drawer'));
    if (!drawer || !sections) return false;
    if (typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        id: null,
        sections: sections
      });
      return true;
    }
    return false;
  }

  function afterAdd(body) {
    return syncBadge().then(function () {
      var drawer = (document.querySelector && document.querySelector('cart-drawer'));
      if (drawer && body && body.sections && refreshDrawer(body.sections)) {
        busy = false;
        if (V.lastQuote) V.paintSummary(V.lastQuote);
        return;
      }
      location.href = V.routes.cart;
    }).catch(function () {
      location.href = V.routes.cart;
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-atc]') : null;
    var q = V.lastQuote;
    if (!b || b.disabled || busy || !q || !q.items || !q.items.length) return;

    busy = true;
    document.querySelectorAll('[data-atc]').forEach(function (n) { n.disabled = true; n.textContent = 'Adding…'; });

    var drawer = (document.querySelector && document.querySelector('cart-drawer'));
    var payload = { items: q.items };
    if (drawer) {
      payload.sections = 'cart-drawer,cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    fetch(V.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) { fail(q, body.description || body.message || 'Could not add to cart. Try again.'); return; }
        return afterAdd(body);
      });
    }).catch(function () { fail(q, 'Could not add to cart. Try again.'); });
  });

  /* ---------- app-268: cart page stepper + trash ----------
     Only three regions are swapped. */
  var WAIT = 250;
  var REGIONS = ['[data-cart-lines]', '[data-cart-note]', '.summary'];
  var SORRY = 'Could not update the cart. Try again.';
  var HOLD = 'Still saving the last change…';   // a tap on a line that is mid-save is dropped; the line says so
  var RETRY = 'Couldn’t refresh the cart. Reload the page to check out.';
  var PATIENCE = 12000;  // a /cart/change.js that never answers must not hold the whole cart hostage
  var pending = {};      // line key → { want, timer }: painted, not sent yet
  var lineBusy = false;  // one /cart/change.js in flight at a time
  var gen = 0;           // request generation: a watchdog that gives up bumps it, so its own late answer is recognised

  function parseQty(raw) {
    var s = String(raw == null ? '' : raw).replace(/^\s+|\s+$/g, '');
    return /^\d+$/.test(s) ? parseInt(s, 10) : null;
  }
  function stepQty(n, step) { return Math.max(1, n + step); }   // − stops at 1: the trash is the one way to remove
  function focusIndex(removed, left) { return left === 0 ? -1 : Math.min(removed, left - 1); }

  V.cartLine = { parseQty: parseQty, stepQty: stepQty, focusIndex: focusIndex };

  // No fetch or DOMParser: url_to_remove and the updates[] form still work without this block.
  // This return leaves the whole IIFE, so this block must stay LAST in the file — anything added after it would not run
  // in such a browser.
  if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

  function closest(node, sel) { return node && node.closest ? node.closest(sel) : null; }
  function root() { return document.querySelector('[data-cart-root]'); }
  function allLines() { var r = root(); return r ? r.querySelectorAll('[data-line-key]') : []; }
  function lineFor(key) {
    var lines = allLines();
    for (var i = 0; i < lines.length; i++) if (lines[i].getAttribute('data-line-key') === key) return lines[i];
    return null;
  }
  function serverQty(line) {
    var n = parseQty(line.getAttribute('data-line-qty'));
    return n === null ? 1 : n;
  }
  function paintQty(line, n) {
    var input = line.querySelector('.qty__input'), minus = line.querySelector('[data-step="-1"]'), plus;
    if (input) input.value = String(n);
    if (!minus) return;
    // Chrome drops focus to <body> the moment a focused button is disabled; hand it to + first. Without this, the
    // shopper who pressed − on the keyboard is standing on <body> by the time hold() reads the focus 250ms later,
    // and land() has nothing to put back. A mouse shopper sees no ring: a button focused from script after a
    // pointer action is not :focus-visible.
    if (n <= 1 && minus === document.activeElement) {
      plus = line.querySelector('[data-step="1"]');
      if (plus && plus.focus) plus.focus();
    }
    minus.disabled = n <= 1;
  }
  function say(line, message) {
    var s = line ? line.querySelector('[data-line-status]') : null;
    if (!s) return;
    // Unhide first: a hidden role="status" is out of the accessibility tree, so text written before this is never read out.
    s.hidden = !message;
    s.textContent = message || '';
  }
  function drop(key) {
    if (pending[key]) { clearTimeout(pending[key].timer); delete pending[key]; }
  }

  // false = could not swap safely; the caller reloads.
  function swap(html) {
    var old = root();
    var next = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]') : null;
    if (!old || !next) return false;
    if (!old.querySelector('[data-cart-lines]') || !next.querySelector('[data-cart-lines]')) {
      old.innerHTML = next.innerHTML;   // cart went empty: the whole page body changes
      return true;
    }
    var pay = old.querySelector('.additional-checkout-buttons');
    // Express buttons showing up for the first time cannot be booted from innerHTML.
    if (!pay && next.querySelector('.additional-checkout-buttons')) return false;
    // Look every region up first and give up if any is missing on either side: writing some of them would leave the
    // old money sitting under the new lines. All or nothing — the caller reloads.
    var from = [], to = [], i;
    for (i = 0; i < REGIONS.length; i++) {
      from[i] = old.querySelector(REGIONS[i]);
      to[i] = next.querySelector(REGIONS[i]);
      if (!from[i] || !to[i]) return false;
    }
    for (i = 0; i < REGIONS.length; i++) from[i].innerHTML = to[i].innerHTML;
    // Put the original express-button node back: its copy from innerHTML never boots. It may reload, but it works.
    var inert = pay ? old.querySelector('.additional-checkout-buttons') : null;
    if (inert && inert !== pay && inert.parentNode) { inert.parentNode.replaceChild(pay, inert); pay.hidden = false; }
    return true;
  }

  // What has focus the instant before a swap, so land() can put it back only when the swap destroys it. Focus that is
  // anywhere else — the Delivery radio, the header, <body> after the shopper dismissed the keyboard — is left alone.
  function hold() {
    var a = document.activeElement, line, step, lines, sel = null, index = 0, i;
    if (!a || !a.closest) return null;
    line = a.closest('[data-line-key]');
    if (!line) return a.closest('.summary') ? { summary: true } : null;
    step = a.closest('[data-step]');
    if (step) sel = step.getAttribute('data-step') === '-1' ? '[data-step="-1"]' : '[data-step="1"]';
    else if (a.closest('.qty__input')) sel = '.qty__input';
    else if (a.closest('.line__remove')) sel = '.line__remove';
    else if (a.closest('.line__title a')) sel = '.line__title a';
    // The held line may not be the line that was changed, so its own index is what the next → previous rule needs.
    lines = allLines();
    for (i = 0; i < lines.length; i++) if (lines[i] === line) index = i;
    return { key: line.getAttribute('data-line-key'), sel: sel, index: index };
  }

  function land(held) {
    var k, l, el, lines, i;
    for (k in pending) {
      if (!Object.prototype.hasOwnProperty.call(pending, k)) continue;
      l = lineFor(k);
      // want 0 is a removal still waiting its turn; painting it would flash a "0" quantity on a line that is still there.
      if (l) { if (pending[k].want !== 0) paintQty(l, pending[k].want); } else drop(k);
    }
    if (!held) return;
    if (held.summary) {
      el = root().querySelector('.summary');
      el = el ? el.querySelector('[name="checkout"]') : null;
    } else if ((l = lineFor(held.key))) {
      // sel null = focus was inside the line but on none of its controls (a click-focused thumb). The line survived,
      // so the shopper's own focus point did too: leave it alone rather than move them to a box they never touched.
      el = held.sel ? l.querySelector(held.sel) : null;
      // Only − is ever disabled, so this is the step down to 1: hand focus along to +. A text input matches
      // :focus-visible even after a mouse click, so landing on the qty box paints the keyboard ring on a shopper who
      // only clicked; a button does not. The box is the last resort, for a line rendered without a +.
      if (held.sel && (!el || el.disabled)) el = l.querySelector('[data-step="1"]') || l.querySelector('.qty__input');
    } else {
      lines = allLines();
      i = focusIndex(held.index, lines.length);
      el = i < 0 ? root().querySelector('[data-cart-empty-cta]') : lines[i].querySelector('.line__title a');
    }
    if (el && el.focus) el.focus();
  }

  // TPC-1191: a change that failed leaves a Summary drawn from a cart that may no longer hold (its stock can have changed).
  // Checkout and the wallets stay off until a fresh render replaces the Summary or the page reloads. A held cart has none.
  function holdCheckout() {
    var r = root(), s = r ? r.querySelector('.summary') : null, b, pay, note;
    if (!s) return;
    b = s.querySelector('[name="checkout"]');
    if (b) b.disabled = true;
    pay = r.querySelector('.additional-checkout-buttons');
    if (pay) pay.hidden = true;
    note = s.querySelector('[data-cart-retry]');
    if (note) { note.hidden = false; note.textContent = RETRY; }
  }

  function refuse(key, message) {
    lineBusy = false;
    holdCheckout();
    var line = lineFor(key);
    if (!line) return;
    line.removeAttribute('aria-busy');
    paintQty(line, serverQty(line));
    say(line, message);
  }

  function send(key, qty) {
    var r = root(), line = lineFor(key), id, mine, guard;
    if (!r || !line) return;
    id = r.getAttribute('data-section-id');
    lineBusy = true;
    line.setAttribute('aria-busy', 'true');
    say(line, '');
    // Nothing bounds a fetch that never settles: without this the line stays busy, every other line's taps re-arm
    // their timer forever, and a painted quantity is never sent. Give up out loud instead.
    mine = ++gen;
    guard = setTimeout(function () {
      if (mine !== gen) return;
      gen++;
      refuse(key, SORRY);
    }, PATIENCE);
    fetch(V.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty, sections: id, sections_url: V.routes.cart })
    }).then(function (res) {
      // Text first, JSON second: a 200 can be Shopify's bot-protection HTML, and res.json() would reject on it — the
      // rejection handler would then repaint the OLD quantity on a line the server has already changed.
      return res.text().then(function (text) {
        var body = null;
        try { body = JSON.parse(text); } catch (e) { body = null; }
        return { ok: res.ok, status: res.status, body: body || {}, json: body != null };
      });
    }).then(function (got) {
      var held;
      clearTimeout(guard);
      // The watchdog already gave up on this one. It answered OK all the same, so Shopify took the change: reload.
      if (mine !== gen) { if (got.ok) location.reload(); return; }
      // 200 we cannot read — Shopify's bot-protection HTML is exactly this shape, and it means the POST never reached
      // the cart. We cannot tell whether the change was taken, so claim nothing: reload and let the cart show the truth.
      if (got.ok && !got.json) { say(lineFor(key), 'Reloading the cart…'); location.reload(); return; }
      if (!got.ok) {
        // 404 = the cart no longer has this line key (a second tab removed it). The whole page is stale, not just
        // this line: refusing here would leave every later action failing the same way.
        if (got.status === 404) { location.reload(); return; }
        refuse(key, got.body.description || got.body.message || SORRY);
        return;
      }
      lineBusy = false;
      if (typeof V.setCartCount === 'function') V.setCartCount(got.body.item_count || 0);
      held = hold();   // read focus last, while the nodes the swap is about to throw away are still the live ones
      if (!swap(got.body.sections && got.body.sections[id])) { location.reload(); return; }
      land(held);
    }, function () {
      clearTimeout(guard);
      if (mine !== gen) return;   // the watchdog already said these words
      refuse(key, SORRY);
    }).catch(function () {
      location.reload();   // Shopify took the change but painting it failed: show the truth
    });
  }

  function flush(key) {
    var p = pending[key], line;
    if (!p) return;
    if (lineBusy) { p.timer = setTimeout(function () { flush(key); }, WAIT); return; }
    drop(key);
    line = lineFor(key);
    if (!line || p.want === serverQty(line)) return;
    send(key, p.want);
  }

  function queue(line, want, wait) {   // wait: ms to hold before flushing; omit it to flush now
    var key = line.getAttribute('data-line-key');
    drop(key);
    pending[key] = { want: want, timer: null };
    if (wait == null) flush(key);
    else pending[key].timer = setTimeout(function () { flush(key); }, wait);
  }

  document.addEventListener('click', function (e) {
    var b = closest(e.target, '[data-step]'), rm = closest(e.target, '.line__remove');
    var line = closest(b || rm, '[data-line-key]'), key, step, from, want;
    if (!line) return;
    if (rm) e.preventDefault();
    if (b && b.disabled) return;
    if (line.getAttribute('aria-busy') === 'true') { say(line, HOLD); return; }
    if (rm) { queue(line, 0); return; }
    key = line.getAttribute('data-line-key');
    step = b.getAttribute('data-step') === '-1' ? -1 : 1;
    from = pending[key] ? pending[key].want : serverQty(line);
    want = stepQty(from, step);
    paintQty(line, want);
    queue(line, want, WAIT);
  });

  document.addEventListener('change', function (e) {
    var input = closest(e.target, '.qty__input'), line = closest(input, '[data-line-key]'), n;
    if (!line) return;
    // Say so and leave the box alone: data-line-qty is still the pre-request quantity, so repainting here would show a
    // number older than the one in flight. The swap paints the truth when the answer lands.
    if (line.getAttribute('aria-busy') === 'true') { say(line, HOLD); return; }
    n = parseQty(input.value);
    if (n === null) { drop(line.getAttribute('data-line-key')); paintQty(line, serverQty(line)); return; }
    // Leaving a dirty box by clicking a control fires this `change` first and the click after. Hold the typed value for
    // a tick so that click takes it instead of hitting a line this already made busy.
    queue(line, n, 0);
  });

  // Enter in the qty box has already fired `change`; do not also POST the no-JS form.
  document.addEventListener('submit', function (e) {
    if (closest(e.target, '[data-cart-lines]')) e.preventDefault();
  });
})(window.Vantor);
